<template>
  <div class="home">
    <Navigation />
    <div class="section bg-primary-3">
      <div class="container text-center">
        <h1>Listing Generator 🏠</h1>
      </div>
    </div>
    <div class="section bg-gray-4">
      <div class="container">
        <div class="w-layout-grid grid-halves card-grid-halves">
          <div class="card-body">
            <div class="form" ms-signup="true">
              <div class="form-group">
                <label>Listing Description</label>
                <textarea v-model="description"  class="form-input text-area-input w-input">
                </textarea>
              </div>
              <div class="form-group">
                <label>Tone</label>
                <select v-model="tone"  class="form-input w-input">
                  <option value="casual">Casual</option>
                  <option value="friendly">Friendly</option>
                  <option value="professional">Professional</option>
                </select>
              </div>
              <div class="form-group">
                <label>Length</label>
                <select v-model="length" class="form-input w-input">
                  <option value="short">Short</option>
                  <option value="medium">Medium</option>
                  <option value="long">Long</option>
                </select>
              </div>
               <button class="button w-button" v-on:click="generate">Generate</button>
            </div>
          </div>
          <div class="card-body">
            <h3>Listing</h3>
            <div class="post-description-container">
              <textarea v-model="listingOutput"
                class="form-input text-area-input w-input post-description"
              >
              </textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navigation from "@/components/Navigation.vue";
import { aiService } from "@/services";
export default {
  name: "home",
  components: {
    Navigation,
  },
  data() {
    return {
      description: "",
      length: "",
      tone:"",
      listingOutput:""
    };
  },
  created() {},
  methods:{
    generate() {
      alert("Generating")
      var listing = {};
      listing.tone = this.tone;
      listing.description = this.description;
      listing.length = this.length;
      console.log(listing);
      aiService.generateListing(listing).then((data) => {
        var post = data;
        this.listingOutput = post;
      });
    },
  }
};
</script>
